angular.module 'zc.commonApi'

# Filters templates by device
.filter 'device', ->
  (templates, device) ->
    _.filter templates, (template) ->
      device in template.support_devices



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/filters/device_filter.js.coffee